/**
 * OpenWarp: 「变量列表值转义」开关（编辑器「高级设置」里可关闭）。
 *
 * 打开（默认，与上游行为一致）：变量/列表的名称、以及积木字段的值写进积木区 XML 时，
 * 会做 XML 实体转义（& → &amp;、< → &lt;、> → &gt;、" → &quot;、' → &apos;），保证 XML 合法。
 * 关闭：这些内容原样写出（高级设置里「变量列表值转义」取消勾选）。
 *   注意：只有在名称/值里不含 < > & ' " 时才能保证积木区 XML 仍能被解析，
 *   否则 scratch-blocks 解析失败，整个积木区会报错。
 *
 * 开关由 Runtime.setRuntimeOptions({variableValueEscape}) 统一设置，
 * 这样编辑器（GUI）只要走既有的 setRuntimeOptions 通道即可，无需新增事件。
 */
const xmlEscape = require('./xml-escape');

let escapeEnabled = true;

/**
 * @return {boolean} 当前是否对变量/列表名称与积木字段值做 XML 转义。
 */
const isVariableValueEscapeEnabled = () => escapeEnabled;

/**
 * @param {boolean} value false 表示关闭转义。
 */
const setVariableValueEscapeEnabled = value => {
    escapeEnabled = (value !== false);
};

/**
 * 变量/列表名称、积木字段值写进 XML 时用这个函数。
 * @param {*} value 变量/列表名称或积木字段值。
 * @return {string} 按开关决定是否做 XML 实体转义的字符串。
 */
const escapeVariableValueForXml = value => (escapeEnabled ? xmlEscape(value) : String(value));

module.exports = {
    isVariableValueEscapeEnabled,
    setVariableValueEscapeEnabled,
    escapeVariableValueForXml
};
